import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function FinalCTA() {
  const checkoutUrl = 'https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778';
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  return <section className="w-full bg-gradient-to-br from-rose-500 via-pink-500 to-rose-400 py-20 sm:py-28" data-id="element-82">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-83">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-84">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 sm:p-12 shadow-2xl" data-id="element-85">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-6" data-id="element-86">
              💛 Compra segura
            </h2>

            <p className="text-xl text-rose-50 mb-10 leading-relaxed" data-id="element-87">
              Si tienes cualquier problema con la descarga, te ayudaremos a
              solucionarlo. Queremos que disfrutes tu kit sin preocupaciones.
            </p>

            <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-8 sm:px-12 py-5 bg-white text-rose-600 text-xl font-bold rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} data-id="element-88">
              👉 Acceder al Mega Kit Ahora — $27.990 ARS
            </motion.a>

            <motion.div className="mt-10 flex flex-wrap justify-center gap-4 text-sm font-medium text-rose-100" initial={{
            opacity: 0
          }} animate={isInView ? {
            opacity: 1
          } : {}} transition={{
            duration: 0.5,
            delay: 0.3
          }} data-id="element-89">
              <span data-id="element-90">✅ Descarga inmediata</span>
              <span className="hidden sm:inline" data-id="element-91">·</span>
              <span data-id="element-92">✅ Compra segura</span>
              <span className="hidden sm:inline" data-id="element-93">·</span>
              <span data-id="element-94">✅ Soporte incluido</span>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}